import { NavLink } from 'react-router-dom';
import { getTeamLogo } from '../../../../../static/logos/TeamLogos';
import clubInfo from "../../../../../static/clubInfo";
import { useIsMatchFinished } from '../../../../../hooks/useIsMatchFinished';


export default function MatchSliderCard({ match, isFirstOfDay }) {
  const currentDate = new Date();
  const monthAbbreviations = {
      1: 'Jan',
      2: 'Feb',
      3: 'Mär',
      4: 'Apr',
      5: 'Mai',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Okt',
      11: 'Nov',
      12: 'Dez'
  };
  const isMatchFinished = useIsMatchFinished(match);

  function formatDateCustom(dateStr) {
      const [day, month] = dateStr.split('.');
      const monthAbbr = monthAbbreviations[parseInt(month)];
      return `${day}. ${monthAbbr}`;
  }

  return (
    <NavLink to={`/spiele/${match.id}`} className="match-slider__link">
      <div className={`match-slider__item`}>
        <div className={`match-slider__card`}>
          <div className="match-slider__header">
            <span className={`match-slider__date ${
                isFirstOfDay ? 'match-slider__date--highlight' : ''
              }`}>
                {formatDateCustom(match.date)}
              </span>
            <span className="match-slider__time">{(isMatchFinished) ? ('BEENDET') : (match.game_time)}</span>
          </div>
          <div className="match-slider__teams">
            <img
              src={getTeamLogo(match.home_team)}
              alt={`${match.home_team} logo`}
              className="match-slider__team-logo"
            />
            {(isMatchFinished) ? (
                <>
                  <span className="match-slider__home-score">{match.home_score}</span>
                  <span className="match-slider__score-divider">:</span>
                  <span className="match-slider__away-score">{match.away_score}</span>
                </>
            ) : (
                <span className="match-slider__vs">VS</span>
            )}
            <img
              src={getTeamLogo(match.away_team)}
              alt={`${match.away_team} logo`}
              className="match-slider__team-logo"
            />
          </div>
          <div className="match-slider__venue">
            {clubInfo.find(club => club.clubee_name === match.home_team)?.details.venue_name}
            <br/>
              {clubInfo.find(club => club.clubee_name === match.home_team)?.details.city}
        </div>
        </div>
      </div>
    </NavLink>
  )
}
